export default function SnapshotObject(obj) {
    return JSON.parse(JSON.stringify(obj));
}